/**
 *
 *
 * @description HDD图册页面
 *
 */
import { Tabs, Button, Modal, Spin } from 'antd';
import NormalPhoto from '@/components/PhotoAlbumBar';
import PhotoAlbumItem from '@/components/PhotoAlbumItem/index';
import {
    getAlbumList,
    getVirtualRoomAlbumList,
    deleteVirtualRoom,
    deleteAlbum as deleteAlbumApi,
    getSelectParamsList,
    getQueueNum,
} from '@/api/hdd/album';
import { useRouterTarget } from '&/utils/customHooks';
import { useHistory, useLocation } from 'react-router-dom';
import { hddDownload } from '&/utils/common';
import Empty from '@/components/PhotoAlbumItem/Empty';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './PhotoAlbum.scss';
import { useEffect } from 'react';

export default function PhotoAlbum() {
    const [activeKey, setActiveKey] = useState('');

    const history = useHistory();

    const location = useLocation();

    usePreventDefault();

    const schemeId =
        new URLSearchParams(window.location.search).get('schemeId') || 1098;

    const [albumList, setAlbumList] = useState([]);

    const [panoramaList, setPanoramaList] = useState([]);

    const [virtualHouseList, setVirtualHouseList] = useState([]);

    const [loading, setLoading] = useState(false);

    const TAB_NAME = new URLSearchParams(window.location.search).get('tab');

    const targetPage = useRouterTarget();

    const albumBar = useRef();

    const panoramaBar = useRef();

    const virtualHouseBar = useRef();

    const timer = useRef();

    const resetSelect = key => {
        let barRef;
        if (key === 'album') {
            barRef = albumBar;
        } else if (key === 'panorama') {
            barRef = panoramaBar;
        } else if (key === 'virtualHouseTour') {
            barRef = virtualHouseBar;
        }
        let resolution = barRef.current?.resolutionItem?.id;
        let space = barRef.current?.spaceItem?.id;
        barRef?.current?.setSelectedAll?.(false);
        return { resolution, space };
    };

    const onChange = async key => {
        setActiveKey(key);

        if (!location.search.includes('tab')) {
            location.search = location.search + '&tab=' + key;

            history.replace(location.search);
        } else {
            let searchParams = new URLSearchParams(location.search);

            searchParams.set('tab', key);

            let searchStr = '?' + searchParams.toString();

            history.replace(searchStr);
        }
        const { resolution, space } = resetSelect(key);
        getList(key, resolution, space);
    };

    const getQueueNumFn = renderQueueIds => {
        return getQueueNum({ renderIds: renderQueueIds }).then(res => {
            return res.data;
        });
    };

    const formatList = (
        list,
        type,
        resolution,
        roomType,
        setList,
        getListFn,
        resetCheck
    ) => {
        list.map(v => {
            if (!v.hasOwnProperty('checked')) {
                console.log(111);
                v.checked = false;
            }
            return v;
        });

        const renderQueueIds = list.filter(v => +v.status === 0).map(v => v.id);

        const renderingList = list.filter(v => +v.status === 1);

        const updateList = () => {
            setList(prev => {
                list.map(v => {
                    let curItem = prev.find(item => item.id === v.id);
                    if (curItem && resetCheck) {
                        v.checked = curItem.checked;
                    } else {
                        v.checked = false;
                    }
                    return v;
                });
                return list;
            });
            // setList([...list])
        };

        if (renderQueueIds.length !== 0) {
            //排队中，继续自动请求列表，直到渲染完成
            return getQueueNumFn(renderQueueIds).then(res => {
                list.map(v => {
                    v.orderNum = res[v.id]?.orderNum;
                    return v;
                });
                updateList();
                timer.current = setTimeout(() => {
                    getListFn(type, resolution, roomType, true, true);
                }, 10000);
            });
        } else if (renderingList !== 0) {
            //渲染中，继续自动请求列表，直到渲染完成
            updateList();
            timer.current = setTimeout(() => {
                getListFn(type, resolution, roomType, true, true);
            }, 10000);
            return Promise.resolve();
        } else {
            clearTimeout(timer.current);
            updateList();
            return Promise.resolve();
        }
    };

    const getList = (type, resolution, roomType, first, resetCheck) => {
        if (!first) {
            setLoading(true);
        }
        clearTimeout(timer.current);
        if (type === 'album' || type === 'panorama') {
            getAlbumList({
                hDocId: schemeId,
                renderType: type === 'album' ? 0 : 1,
                resolution: resolution !== 'all' ? resolution : undefined,
                roomType: roomType !== 'all' ? roomType : undefined,
            })
                .then(res => {
                    let list = res.data.list;
                    let setListFn =
                        type === 'album' ? setAlbumList : setPanoramaList;
                    return formatList(
                        list,
                        type,
                        resolution,
                        roomType,
                        setListFn,
                        getList,
                        resetCheck
                    );
                })
                .finally(() => {
                    setLoading(false);
                });
        } else if (type === 'virtualHouseTour') {
            getVirtualRoomAlbumList({ hDocId: schemeId, getSpace: 1 })
                .then(res => {
                    let list = res.data.list;
                    list.map(v => (v.checked = false));
                    setVirtualHouseList(list);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const [resolution, setResolution] = useState([
        { id: 'all', name: '全部分辨率' },
    ]);

    const [space, setSpace] = useState([{ id: 'all', name: '全部空间' }]);

    const getSelectParams = () => {
        let params = { hDocId: schemeId };
        if (activeKey === 'album') {
            params.renderType = 0;
        } else if (activeKey === 'panorama') {
            params.renderType = 1;
        } else {
            return;
        }
        getSelectParamsList(params).then(res => {
            console.log(res, 'getSelectParamsList');
            let resolutionList = res.data.list.resolution?.map(v => ({
                id: v.resolution,
                name: v.resolution,
            }));
            let spaceList = res.data.list.roomType?.map(v => ({
                id: v.roomType,
                name: v.roomType,
            }));
            resolutionList.unshift({ id: 'all', name: '全部分辨率' });
            spaceList.unshift({ id: 'all', name: '全部空间' });
            setResolution(resolutionList);
            setSpace(spaceList);
        });
    };

    useEffect(() => {
        getSelectParams();
    }, [activeKey]);

    useEffect(() => {
        // 获取普通图册数据
        onChange(TAB_NAME || 'album');

        console.log('window.location.href', window.location.href);

        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const deleteAlbum = (id, type) => {
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                console.log(id, type, 'deleteAlbum');
                if (['album', 'panorama'].includes(type)) {
                    deleteAlbumApi({ renderIds: [id] }).then(() => {
                        getList(type);
                        close();
                    });
                } else if (type === 'virtualHouseTour') {
                    deleteVirtualRoom({ ids: [id] }).then(() => {
                        getList(activeKey);
                        close();
                    });
                }
                resetSelect(activeKey);
            },
            onCancel: close => {
                close();
            },
        });
    };

    const albumState = {
        '-1': 'beforeQueue',
        0: 'inQueue',
        1: 'rendering',
        2: 'rendered',
        3: 'failed',
    };

    const onAllSelectChange = checked => {
        if (activeKey === 'album') {
            let list = [...albumList];
            list.map(v => (v.checked = checked));
            setAlbumList(list);
        } else if (activeKey === 'panorama') {
            let list = [...panoramaList];
            list.map(v => (v.checked = checked));
            setPanoramaList(list);
        } else if (activeKey === 'virtualHouseTour') {
            let list = [...virtualHouseList];
            list.map(v => (v.checked = checked));
            setVirtualHouseList(list);
        }
    };

    const onDownload = () => {
        let urls = [];
        if (activeKey === 'album') {
            urls = albumList;
        } else if (activeKey === 'panorama') {
            urls = panoramaList;
        }
        urls = urls
            .filter(v => v.checked && +v.status === 2)
            .map(v => ({ picturepath: v.renderUrl, picturename: v.title }));
        hddDownload(urls);
    };

    const onDelete = () => {
        let ids = [];
        if (activeKey === 'album') {
            ids = albumList
                .filter(v => v.checked && +v.status === 2)
                .map(v => v.id);
        } else if (activeKey === 'panorama') {
            ids = panoramaList
                .filter(v => v.checked && +v.status === 2)
                .map(v => v.id);
        } else if (activeKey === 'virtualHouseTour') {
            ids = virtualHouseList.filter(v => v.checked).map(v => v.id);
        }
        console.log('ids', ids);
        if (ids.length === 0) {
            Modal.info({
                title: null,
                icon: null,
                content: `请选择要删除的图册`,
                okText: '确认',
                cancelText: '取消',
            });
            return;
        }
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                console.log(ids, 'deleteAlbum');
                if (['album', 'panorama'].includes(activeKey)) {
                    deleteAlbumApi({ renderIds: ids }).then(() => {
                        getList(activeKey);
                        close();
                    });
                } else if (activeKey === 'virtualHouseTour') {
                    deleteVirtualRoom({ ids }).then(() => {
                        getList(activeKey);

                        close();
                    });
                }
                resetSelect(activeKey);
            },
            onCancel: close => {
                close();
            },
        });
    };

    const checkedFn = (prevList, checked, barRef, setList, index) => {
        let list = [...prevList];
        list[index].checked = checked;
        if (list.filter(v => +v.status === 2).every(v => v.checked)) {
            console.log('all');
            barRef.current.setSelectedAll(true);
        } else {
            barRef.current.setSelectedAll(false);
        }
        if (list.some(v => v.checked)) {
            barRef.current.setIsShowOperateBtn(true);
        } else {
            barRef.current.setIsShowOperateBtn(false);
        }
        setList(list);
    };

    const handleCreateAlbum = () => {
        console.log('handleCreateAlbum');
        try {
            window.external.DispatchFun('Atlas', 'CreateNormalImage', '');
        } catch (e) {}
    };

    const handleCreatePanorama = () => {
        console.log('handleCreatePanorama');
        try {
            window.external.DispatchFun('Atlas', 'CratePanoramaImage', '');
        } catch (e) {}
    };

    const handleCreateVrRoom = () => {
        console.log('handleCreateVrRoom');
        targetPage({
            pathname: '/hdd/virtualHouseCerate',
            search: { schemeId },
        });
    };

    const handleExit = () => {
        try {
            window.external.DispatchFun('Atlas', 'AtlasExit', '');
        } catch (e) {}
    };

    return (
        <Spin spinning={loading}>
            <div className="photo-album">
                <div className="title">图册</div>
                <Tabs centered activeKey={activeKey} onChange={onChange}>
                    <Tabs.TabPane tab="普通图" key="album">
                        <NormalPhoto
                            isPhoto={true}
                            onAllSelectChange={onAllSelectChange}
                            onDelete={onDelete}
                            ref={albumBar}
                            resolution={resolution}
                            space={space}
                            total={albumList.length}
                            onParamsChange={(resolution, space) => {
                                getList(activeKey, resolution, space);
                            }}
                            onDownload={onDownload}
                        />
                        <div
                            className={`item-wrap ${
                                !albumList.length ? 'item-wrap-empty' : ''
                            }`}>
                            {albumList.map((item, index) => {
                                return (
                                    <PhotoAlbumItem
                                        key={index}
                                        deleteFn={id =>
                                            deleteAlbum(id, 'album')
                                        }
                                        itemType="album"
                                        itemState={albumState[item.status]}
                                        {...item}
                                        schemeId={schemeId}
                                        getCurList={() => getList(activeKey)}
                                        checkedFn={checked => {
                                            checkedFn(
                                                albumList,
                                                checked,
                                                albumBar,
                                                setAlbumList,
                                                index
                                            );
                                        }}
                                    />
                                );
                            })}
                            {!albumList.length && (
                                <Empty
                                    tip="暂无普通图，请先渲染"
                                    btnWord="创建普通图"
                                    handleCreate={handleCreateAlbum}
                                />
                            )}
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="全景图" key="panorama">
                        <NormalPhoto
                            ref={panoramaBar}
                            resolution={resolution}
                            space={space}
                            total={panoramaList.length}
                            onAllSelectChange={onAllSelectChange}
                            onDelete={onDelete}
                            onParamsChange={(resolution, space) => {
                                getList(activeKey, resolution, space);
                            }}
                            onDownload={onDownload}
                        />
                        <div
                            className={`item-wrap ${
                                !panoramaList.length ? 'item-wrap-empty' : ''
                            }`}>
                            {panoramaList.map((item, index) => {
                                return (
                                    <PhotoAlbumItem
                                        key={index}
                                        deleteFn={id =>
                                            deleteAlbum(id, 'panorama')
                                        }
                                        itemType="panorama"
                                        itemState={albumState[item.status]}
                                        {...item}
                                        schemeId={schemeId}
                                        getCurList={() => getList(activeKey)}
                                        checkedFn={checked => {
                                            checkedFn(
                                                panoramaList,
                                                checked,
                                                panoramaBar,
                                                setPanoramaList,
                                                index
                                            );
                                        }}
                                    />
                                );
                            })}
                            {!panoramaList.length && (
                                <Empty
                                    tip="暂无全景图，请先渲染"
                                    btnWord="创建全景图"
                                    handleCreate={handleCreatePanorama}
                                />
                            )}
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="全屋漫游图" key="virtualHouseTour">
                        <NormalPhoto
                            isVrRoom={true}
                            ref={virtualHouseBar}
                            onAllSelectChange={onAllSelectChange}
                            onDelete={onDelete}
                            schemeId={schemeId}
                            total={virtualHouseList.length}
                        />
                        <div
                            className={`item-wrap ${
                                !virtualHouseList.length
                                    ? 'item-wrap-empty'
                                    : ''
                            }`}>
                            {virtualHouseList.map((item, index) => {
                                return (
                                    <PhotoAlbumItem
                                        key={index}
                                        deleteFn={id =>
                                            deleteAlbum(id, 'virtualHouseTour')
                                        }
                                        itemType="panoramaVrRoom"
                                        itemState={albumState[2]}
                                        {...item}
                                        coverImageUrl={
                                            item?.render?.[
                                                item?.renderIdList?.split(
                                                    ','
                                                )?.[0]
                                            ]?.coverImageUrl
                                        }
                                        resolution={`x${
                                            item?.renderIdList?.split(',')
                                                ?.length
                                        }张`}
                                        schemeId={schemeId}
                                        checkedFn={checked => {
                                            checkedFn(
                                                virtualHouseList,
                                                checked,
                                                virtualHouseBar,
                                                setVirtualHouseList,
                                                index
                                            );
                                        }}
                                    />
                                );
                            })}
                            {!virtualHouseList.length && (
                                <Empty
                                    tip="暂无全屋漫游图"
                                    btnWord="创建全屋漫游图"
                                    handleCreate={handleCreateVrRoom}
                                />
                            )}
                        </div>
                    </Tabs.TabPane>
                </Tabs>
                <Button className="exit" onClick={handleExit}>
                    退出
                </Button>
            </div>
        </Spin>
    );
}
